<template>
  <v-container fluid class="pa-8">
    <div class="d-flex flex-column align-center justify-center">
      <h2>Logged out successfully</h2>
      <div>
        <v-btn to="/login" color="primary black--text">Login</v-btn>
      </div>
    </div>
  </v-container>
</template>
<script>
export default {
  mounted() {
    this.$log.debug("LogoutSuccess");
  },
};
</script>
